package team.platforma.chat_presentation.model

import com.platforma.chat_domain.MessageStatus
import team.platforma.chat_presentation.Status

data class MessagePresentation(
    val text: String,
    val status: Status,
    val senderId: Long
)
